/*
 * @Author: Allan 
 * @Date: 2021-01-30 10:49:33 
 * @explain: 请求封装
 * @Last Modified time: 2021-01-30 10:49:33 
 */

import axios from 'axios';
import store from '@/store/index';

export default function(url, options = {}, auth = true, ifTokenNeccessary = false, header = {}) {
  return new Promise(async (resolve, reject) => {
    options = {
      url,
      ...options,
    };

    // 添加token
    if (auth) {
      // console.log(auth)
      // 如果是必要token请求的接口 没有登录的玩家无法请求
      if(ifTokenNeccessary && !store.state.globalState.token){
        return
      }

      options = {
        ...options,
        headers: {
          ...header,
          'x-bits-token': store.state.globalState.token,
        },
      };

      // console.log(store.state.userState.token)
    }

    try {
      const res = await axios(options);
      const data = res.data;

      if("code" in data) {
        if(data.code === 200){
          return resolve(data);
        }
      } else {
        if(res.status === 200){
          return resolve(data);
        }
      }

      reject(data);

    } catch(error) {
      reject(error);
    }
  });
}
